import { Record } from 'immutable';
import remove from 'lodash/fp/remove';
import * as types from './actionTypes';
import constants from '../constants';

const requestReducerState = Record({
  groups: [],
  group: {
    id: null,
  },
  tmpGroup: {},
  makes: [],
  step: 0, // a counter of what step is active in the ui
  ymmt: { years: [] },
  [constants.ERROR_KEY]: null,
  [constants.SUCCESS_KEY]: null,
  [constants.FETCHING_KEY]: false,
});

export default (state = requestReducerState(), action) => {
  const { type, payload } = action;
  switch (type) {
    case types.GROUPS_SUCCESS:
      return state
        .set(constants.ERROR_KEY, null)
        .set(constants.FETCHING_KEY, false)
        .set('groups', payload);
    case types.GROUP_SUCCESS:
    case types.CREATE_GROUP_SUCCESS:
    case types.UPDATE_GROUP_SUCCESS: {
      const feeds = payload.Feeds ? payload.Feeds.map((f) => f.id) : undefined;
      return state
        .set(constants.ERROR_KEY, null)
        .set(constants.SUCCESS_KEY, null)
        .set(constants.FETCHING_KEY, false)
        .set('group', { ...payload, feeds });
    }
    case types.DELETE_GROUP_SUCCESS:
      return state
        .set(constants.ERROR_KEY, null)
        .set(constants.SUCCESS_KEY, null)
        .set(constants.FETCHING_KEY, false)
        .set('groups', remove({ id: payload })(state.groups));
    case types.GROUPS_REQUEST:
    case types.GROUP_REQUEST:
    case types.CREATE_GROUP_REQUEST:
    case types.UPDATE_GROUP_REQUEST:
    case types.DELETE_GROUP_REQUEST:
      return state
        .set(constants.ERROR_KEY, null)
        .set(constants.SUCCESS_KEY, null)
        .set(constants.FETCHING_KEY, true);
    case types.GROUPS_FAILURE:
    case types.GROUP_FAILURE:
    case types.CREATE_GROUP_FAILURE:
    case types.UPDATE_GROUP_FAILURE:
    case types.DELETE_GROUP_FAILURE:
    case types.RESET_GROUP:
      return state
        .set('group', requestReducerState().group)
        .set('fetching', false)
        .set('error', payload);
    default:
      return state;
  }
};
